import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["to", "href", "forceExternal"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEmbedMode } from '@infl-ts/util-embed-mode-provider';
import { pipe } from 'fp-ts/function';
import { createPath } from 'history';
import { forwardRef } from 'react';
import { ExternalLink } from '../external-link';
import { RouterLink } from '../router-link';
import { jsx as _jsx } from "react/jsx-runtime";

var isInternalLink = function isInternalLink(href) {
  return href && href.startsWith('/') && !href.startsWith('/forum');
};

// TODO(shane): fix this up to be proper, or find another way to do this
var convertToToPath = function convertToToPath(to, convertToEmbedPath) {
  if (!window || typeof to === 'function') return '';
  return pipe(typeof to === 'string' ? to : createPath(to), convertToEmbedPath, function (path) {
    return isInternalLink(path) ? "".concat(window.location.origin).concat(path !== null && path !== void 0 ? path : '') : path;
  });
};

export var Link = /*#__PURE__*/forwardRef(function Link(_ref, ref) {
  var to = _ref.to,
      href = _ref.href,
      _ref$forceExternal = _ref.forceExternal,
      forceExternal = _ref$forceExternal === void 0 ? false : _ref$forceExternal,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useEmbedMode = useEmbedMode(),
      isEmbedded = _useEmbedMode.isEmbedded,
      convertToEmbedPath = _useEmbedMode.convertToEmbedPath;

  return !forceExternal && (to || isInternalLink(href)) && !isEmbedded ? /*#__PURE__*/_jsx(RouterLink, _objectSpread({
    ref: ref,
    to: to || href || ''
  }, props)) : /*#__PURE__*/_jsx(ExternalLink, _objectSpread(_objectSpread({
    ref: ref,
    href: convertToEmbedPath(href) || to && convertToToPath(to, convertToEmbedPath) || ''
  }, props.target === '_blank' ? {
    rel: 'noopener noreferrer'
  } : undefined), props));
});